import { Box, Stack, Typography } from "@mui/material";
import getAlphabetForIndex, { FontFamily } from "./getAlphabetForIndex";
import PreviewComponent from "../../mockTest/QuestionFormComponentMock/previewComponent";
import globalColors from "../../../globalColors";
import Chip from "./chip/Chip";
import { formatOptions, formatTags } from "../../../Components/QuestionPreview";
import QuizLanguageToggle, {
  QuizLanguageToggleProps,
} from "../quizLanguageToggle/QuizLanguageToggle";
import { useAppDispatch } from "../../../hooks/storeHooks";
import { showSnack } from "../../../store/slices/constants";

function MobileEmulator({
  submittedData,
  languge,
}: {
  submittedData: any;
  languge: QuizLanguageToggleProps;
}) {
  const dispatch = useAppDispatch();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        // bgcolor: "#f3f3f3", // background like emulator environment
      }}
    >
      <style>{`img {max-width:100%}`}</style>
      <Box
        sx={{
          width: "100%", // typical iPhone width
          height: "100%", // typical iPhone X height
          boxSizing: "border-box",
          border: "6px solid #000",
          borderRadius: "40px",
          position: "relative",
          // overflow: "hidden",
          bgcolor: "#fff",
        }}
      >
        {/* Notch */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: 200,
            maxWidth: "80%",
            height: 18,
            bgcolor: "#000",
            borderBottomLeftRadius: 20,
            borderBottomRightRadius: 20,
            zIndex: 10,
          }}
        ></Box>
        <Box
          sx={{
            position: "absolute",
            top: "-3px",
            width: "100%",
            zIndex: 10,
            color: "white",
            justifyContent: "center",
            display: "flex",
            fontWeight: "bold",
          }}
        >
          Preview
        </Box>

        {/* Inner app content */}
        <Stack
          sx={{
            position: "relative",
            width: "100%",
            height: "calc(100% - 30px)",
            overflowY: "auto",
            mt: "15px", // padding to avoid notch
            mb: "15px", // padding for bottom bar
            boxSizing: "border-box",
          }}
        >
          {" "}
          <Stack alignItems={"center"} width={"100%"} my={"16px"}>
            <QuizLanguageToggle {...languge} />
          </Stack>
          <Stack
            flexDirection={"column"}
            justifyContent={"space-between"}
            mb={"11px"}
            p="5px 19px"
            // <Stack style={{ padding: "20px 30px 0px 30px" }}>
          >
            <Typography
              color={"#121212"}
              fontFamily={FontFamily.gilroy}
              fontSize={"16px"}
              fontWeight={700}
              lineHeight={"125%"}
              letterSpacing={"-0.32px"}
              width="100%"
              mb={"11px"}
            >
              Question
            </Typography>
            <Typography
              component={"div"}
              color={"#121212"}
              fontWeight={400}
              fontSize={"16px"}
              lineHeight={"125%"}
              fontFamily={FontFamily.gilroy}
              sx={{ cursor: "text" }}
              onClick={() => {
                navigator.clipboard.writeText(submittedData["Question"]);
                dispatch(
                  showSnack({
                    open: true,
                    severity: "success",
                    message: `Question Copied.`,
                  })
                );
              }}
            >
              <PreviewComponent htmlContent={submittedData["Question"]} />
            </Typography>

            {/* <div dangerouslySetInnerHTML={{ __html: submittedData["Question"] }} style={{ paddingTop: "15px", fontSize: "15px" }}></div> */}
            <Stack gap={"8px"} mt={"16px"}>
              {(submittedData["Option A"]?.length > 0 ||
                submittedData["Option B"]?.length > 0 ||
                submittedData["Option C"]?.length > 0 ||
                submittedData["Option D"]?.length > 0) && (
                <>
                  <Stack
                    direction={"row"}
                    gap={"10px"}
                    component={"button"}
                    p={"12px"}
                    border={
                      submittedData["correct_answer"]?.label === "Option A"
                        ? "2px solid"
                        : "1px solid"
                    }
                    borderRadius={"5px"}
                    borderColor={
                      submittedData["correct_answer"]?.label === "Option A"
                        ? "#1CAA6E"
                        : "#C8C8C8"
                    }
                    bgcolor={
                      submittedData["correct_answer"]?.label === "Option A"
                        ? "#E4F5EE"
                        : "#FFFFFF"
                    }
                    sx={{
                      cursor: "pointer",
                    }}
                  >
                    <Typography
                      fontStyle={"normal"}
                      fontWeight={400}
                      fontSize={"16px"}
                      lineHeight={"125%"}
                      textAlign={"left"}
                      fontFamily={FontFamily.gilroy}
                    >
                      <span>{`${getAlphabetForIndex(0)}. `}</span>
                    </Typography>
                    <Typography
                      fontStyle={"normal"}
                      fontWeight={400}
                      fontSize={"16px"}
                      lineHeight={"125%"}
                      textAlign={"left"}
                      fontFamily={FontFamily.gilroy}
                    >
                      <PreviewComponent
                        htmlContent={formatOptions(submittedData["Option A"])}
                      />
                    </Typography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    gap={"10px"}
                    component={"button"}
                    p={"12px"}
                    border={
                      submittedData["correct_answer"]?.label === "Option B"
                        ? "2px solid"
                        : "1px solid"
                    }
                    borderRadius={"5px"}
                    borderColor={
                      submittedData["correct_answer"]?.label === "Option B"
                        ? "#1CAA6E"
                        : "#C8C8C8"
                    }
                    bgcolor={
                      submittedData["correct_answer"]?.label === "Option B"
                        ? "#E4F5EE"
                        : "#FFFFFF"
                    }
                    sx={{
                      cursor: "pointer",
                    }}
                  >
                    <Typography
                      fontStyle={"normal"}
                      fontWeight={400}
                      fontSize={"16px"}
                      lineHeight={"125%"}
                      textAlign={"left"}
                      fontFamily={FontFamily.gilroy}
                    >
                      <span>{`${getAlphabetForIndex(1)}. `}</span>
                    </Typography>
                    <Typography
                      fontStyle={"normal"}
                      fontWeight={400}
                      fontSize={"16px"}
                      lineHeight={"125%"}
                      textAlign={"left"}
                      fontFamily={FontFamily.gilroy}
                    >
                      <PreviewComponent
                        htmlContent={formatOptions(submittedData["Option B"])}
                      />
                    </Typography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    gap={"10px"}
                    component={"button"}
                    p={"12px"}
                    border={
                      submittedData["correct_answer"]?.label === "Option C"
                        ? "2px solid"
                        : "1px solid"
                    }
                    borderRadius={"5px"}
                    borderColor={
                      submittedData["correct_answer"]?.label === "Option C"
                        ? "#1CAA6E"
                        : "#C8C8C8"
                    }
                    bgcolor={
                      submittedData["correct_answer"]?.label === "Option C"
                        ? "#E4F5EE"
                        : "#FFFFFF"
                    }
                    sx={{
                      cursor: "pointer",
                    }}
                  >
                    <Typography
                      fontStyle={"normal"}
                      fontWeight={400}
                      fontSize={"16px"}
                      lineHeight={"125%"}
                      textAlign={"left"}
                      fontFamily={FontFamily.gilroy}
                    >
                      <span>{`${getAlphabetForIndex(2)}. `}</span>
                    </Typography>
                    <Typography
                      fontStyle={"normal"}
                      fontWeight={400}
                      fontSize={"16px"}
                      lineHeight={"125%"}
                      textAlign={"left"}
                      fontFamily={FontFamily.gilroy}
                    >
                      <PreviewComponent
                        htmlContent={formatOptions(submittedData["Option C"])}
                      />
                    </Typography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    gap={"10px"}
                    component={"button"}
                    p={"12px"}
                    border={
                      submittedData["correct_answer"]?.label === "Option D"
                        ? "2px solid"
                        : "1px solid"
                    }
                    borderRadius={"5px"}
                    borderColor={
                      submittedData["correct_answer"]?.label === "Option D"
                        ? "#1CAA6E"
                        : "#C8C8C8"
                    }
                    bgcolor={
                      submittedData["correct_answer"]?.label === "Option D"
                        ? "#E4F5EE"
                        : "#FFFFFF"
                    }
                    sx={{
                      cursor: "pointer",
                    }}
                  >
                    <Typography
                      fontStyle={"normal"}
                      fontWeight={400}
                      fontSize={"16px"}
                      lineHeight={"125%"}
                      textAlign={"left"}
                      fontFamily={FontFamily.gilroy}
                    >
                      <span>{`${getAlphabetForIndex(3)}. `}</span>
                    </Typography>
                    <Typography
                      fontStyle={"normal"}
                      fontWeight={400}
                      fontSize={"16px"}
                      lineHeight={"125%"}
                      textAlign={"left"}
                      fontFamily={FontFamily.gilroy}
                    >
                      <PreviewComponent
                        htmlContent={formatOptions(submittedData["Option D"])}
                      />
                    </Typography>
                  </Stack>
                </>
              )}
              {submittedData["Explanation"]?.length > 0 && (
                <Stack spacing={"8px"} sx={{ listStylePosition: "inside" }}>
                  <Stack
                    px={"8px"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                  >
                    <Typography
                      fontFamily={FontFamily.gilroy}
                      color={globalColors.primary.black}
                    >
                      Solution
                    </Typography>
                  </Stack>
                  <Stack
                    borderRadius={"5px"}
                    bgcolor={globalColors.primary.lightGrey}
                    p={"8px"}
                  >
                    <Typography fontFamily={FontFamily.gilroy}>
                      <PreviewComponent
                        htmlContent={submittedData["Explanation"]}
                      />{" "}
                    </Typography>
                  </Stack>
                </Stack>
              )}
              {submittedData["Question Tags"]?.length > 0 && (
                <Stack flexDirection={"row"} flexWrap={"wrap"} gap={"10px"}>
                  <Stack alignSelf={"flex-start"}>
                    {submittedData["Question Tags"]?.map(({ name }: any) => {
                      return (
                        <Stack mb={"8px"} key={name}>
                          <Chip
                            label={`${formatTags(name)}`}
                            color={"#FF5100"}
                          />
                        </Stack>
                      );
                    })}
                  </Stack>
                </Stack>

                //       {map((d: any) => (
                //         <Chip
                //           sx={{
                //             margin: "5px",
                //             background: "#E3F4E7",
                //             maxWidth: "calc(100% - 10px)",
                //             "& .MuiChip-label": {
                //               fontSize: "0.69srem",
                //               lineHeight: "1rem",
                //             },
                //           }}
                //           label={d.name}
                //           variant="outlined"
                //         />
                //       ))}
                //     </ul>
                //   </div>
              )}
            </Stack>
          </Stack>
        </Stack>

        {/* Home indicator */}
        <Box
          sx={{
            position: "absolute",
            bottom: 8,
            left: "50%",
            transform: "translateX(-50%)",
            width: 120,
            height: 5,
            bgcolor: "#999",
            borderRadius: 3,
          }}
        />
      </Box>
    </Box>
  );
}

export default MobileEmulator;
